<template>
 <v-app class="green lighten-4" >
<NavBar/>
<v-content>
  <router-view></router-view>
</v-content>
 </v-app> 
</template>

<script>

 import NavBar from './components/NavBar.vue'
export default {
  name: 'App',

  components: {
NavBar
  },

  data: () => ({
    //
  }),
}
</script>
